<template>
  <div class="page-add">
    <div class="add-title">{{ !editId ? "新增申报" : "编辑申报" }}</div>
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="120px"
      :rules="rules"
      :model="classForm"
      ref="classForm"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="讲座主题：" prop="lectureName">
            <el-input
              style="width: 100%"
              v-model="classForm.lectureName"
              placeholder="请输入讲座主题"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <el-form-item label="授课老师：" prop="teacher">
            <el-input
              style="width: 100%"
              v-model="classForm.teacher"
              placeholder="请输入授课老师姓名"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <div class="unit_style">
            <div class="devide_line">—</div>
            <el-form-item
              class="period_form"
              prop="teacherUnitPosition"
              style="width: 100%"
            >
              <el-input
                v-model="classForm.teacherUnitPosition"
                placeholder="请输入授课老师职务职称"
              >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="讲座时间：" prop="lectureTime">
            <el-date-picker
              style="width: 100%"
              v-model="classForm.lectureTime"
              type="date"
              clearable
              placeholder="请选择讲座时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :pickerOptions="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="开始时间：" prop="lectureStartDate">
            <el-time-select
              placeholder="请选择开始时间"
              v-model="classForm.lectureStartDate"
              :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '23:59',
                maxTime: classForm.lectureEndDate,
              }"
              @change="timeChange"
            >
            </el-time-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="结束时间：" prop="lectureEndDate">
            <el-time-select
              placeholder="请选择结束时间"
              v-model="classForm.lectureEndDate"
              :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '23:59',
                minTime: classForm.lectureStartDate,
              }"
              @change="timeChange"
            >
            </el-time-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="学时(小时)：" prop="lectureHours">
            <el-input
              v-model="classForm.lectureHours"
              placeholder="请输入学时"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              @change="inputHours"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="讲座地点：" prop="lecturePlace">
            <el-input
              v-model="classForm.lecturePlace"
              placeholder="请输入讲座地点"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="主办单位：" prop="organizer">
            <el-input
              v-model="classForm.organizer"
              placeholder="请输入主办单位"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="通知文件：" prop="attachmentList">
            <upload
              :limit="1"
              :path="'topicLecture/attachment'"
              v-model="classForm.attachmentList"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="现场照片：" prop="sitePhotosList">
            <div class="photos_style">
              <av-preview
                v-for="(item, i) in classForm.sitePhotosList"
                :key="'photo' + i"
                :src="item.url"
                type="image"
                @delete="deleteSitePhotos(i)"
              />
              <div
                class="upload_rect"
                v-if="
                  classForm.sitePhotosList &&
                  classForm.sitePhotosList.length < 3
                "
              >
                <upload
                  :limit="3"
                  :draggable="false"
                  type="image"
                  accept="png,jpg,jpeg"
                  :path="'topicLecture/attachment'"
                  v-model="classForm.sitePhotosList"
                />
                <div class="upload_tip">
                  <p class="img_tip">只能上传jpg/png格式文件，且不超过20Mb</p>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="m-t-l" label="学员名单：" required>
            <person-list ref="persons" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="form-handle form-text-center" label-width="0">
            <back-button :floatLeft="false" />
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { addDeclare, getIntervalCredit } from "@/api/topicLecture";
import { getSysParamByTypes } from "@/api/sysParam";
import Upload from "@/components/upload/index";
import rulesFactory from "@/utils/rules";
import { setItem } from "@/utils/storage.js";
import BackButton from "@/components/backButton/index";
import PersonList from "./personList";
import AvPreview from "@/components/av-preview/index";
import { calculateHoursBetweenTimes } from "../../../utils/common";
import {pickerOptions} from "@/utils/timeFormat.js"

export default {
  name: "topicLectureReportAdd",
  components: { Upload, BackButton, PersonList, AvPreview },
  provide() {
    return {
      form: this,
    };
  },
  data() {
    return {
      pickerOptions: pickerOptions,
      editId: null, // 编辑
      rulesFactory,
      classForm: {
        lectureName: "",
        teacher: "",
      },
      rules: {
        lectureName: [
          rulesFactory.required("请输入讲座主题"),
          rulesFactory.size("最多输入100个字", 0, 100),
        ],
        teacher: [
          rulesFactory.required("请输入授课老师姓名"),
          rulesFactory.size("最多输入30个字", 0, 30),
        ],
        teacherUnitPosition: [
          rulesFactory.required("请输入授课老师职务职称"),
          rulesFactory.size("最多输入255个字", 0, 255),
        ],
        lectureTime: [rulesFactory.required("请选择讲座时间")],
        lectureStartDate: [rulesFactory.required("请选择开始时间")],
        lectureEndDate: [rulesFactory.required("请选择结束时间")],
        lectureHours: [
          {
            required: true,
            validator: this.limitInput,
            trigger: ["blur", "change"],
          },
        ],
        lecturePlace: [
          rulesFactory.required("请输入讲座地点"),
          rulesFactory.size("最多输入100个字", 0, 100),
        ],
        organizer: [
          rulesFactory.required("请输入主办单位"),
          rulesFactory.size("最多输入100个字", 0, 100),
        ],
        attachmentList: [rulesFactory.required("请上传通知文件")],
        sitePhotosList: [rulesFactory.required("请上传现场照片")],
      },
      classInfo: {},
      calculateLectureHours: 0,
    };
  },
  created() {
    this.loadFlag = true;
    this.addInfoDto();
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.dayTimeData = res.data["DATE_AM_PM"] || [];
      });
    },
    // 初始化当前数据
    addInfoDto() {
      this.classForm = {
        lectureName: "",
        teacher: "",
        teacherUnitPosition: "",
        lectureTime: "",
        lecturePlace: "",
        lectureHours: "",
        organizer: "",
        attachment: "",
        attachmentList: [],
        sitePhotos: "",
        sitePhotosList: [],
        userList: [],
      };
    },
    deleteSitePhotos(index) {
      this.classForm.sitePhotosList.splice(index, 1);
    },
    //新增专题讲座申报
    submit() {
      this.$refs["classForm"]
        .validate()
        .then(() => {
          let params = Object.assign({}, this.classForm);
          let rawData = this.classForm;

          if (rawData.attachmentList && rawData.attachmentList.length > 0) {
            params["attachment"] = JSON.stringify(rawData.attachmentList);
          }
          if (rawData.sitePhotosList && rawData.sitePhotosList.length > 0) {
            params["sitePhotos"] = JSON.stringify(rawData.sitePhotosList);
          }
          if (this.$refs["persons"].persons.length === 0) {
            this.$message({
              message: "请选择学员名单",
              type: "error",
            });
            return;
          }
          params.userList = this.$refs["persons"].persons.map((ele) => ({
            userMobile: ele.userMobile,
            userName: ele.userName,
            userId: ele.uuid,
            unitPosition: ele.unitPosition,
            deptName: ele.deptName,
            deptId: ele.deptId,
          }));
          console.log(params);
          addDeclare(params).then((res) => {
            if (!res || res.code != 0) return;
            setItem(this.REFRESH_FLAG, true);
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            this.$router.push("/topicLectureReport");
          });
        })
        .catch(() => {});
    },
    limitInput(rule, value, callback) {
      if (!!value && value.length !== 0) {
        value = String(value).replace(/[^0-9.]/g, "");
      }
      if (!value || value.length === 0) {
        callback(new Error("请输入学时"));
      } else if (parseFloat(value) <= 0) {
        callback(new Error("学时数需大于0"));
      } else if (parseFloat(value) > this.calculateLectureHours) {
        callback(new Error("学时要求：45分钟1学时，不足45分钟按比例换算，半天不超过4学时"));
      } else {
        callback();
      }
    },
    timeChange() {
      if (
        this.classForm.lectureStartDate &&
        this.classForm.lectureStartDate.length > 0 &&
        this.classForm.lectureEndDate &&
        this.classForm.lectureEndDate.length > 0
      ) {
        // let time = calculateHoursBetweenTimes(
        //   this.classForm.lectureStartDate,
        //   this.classForm.lectureEndDate
        // );
        let params = {
          lectureStartDate: this.classForm.lectureStartDate,
          lectureEndDate: this.classForm.lectureEndDate
        }
        getIntervalCredit(params).then((res) => {
          if (!res || res.code != 0) return;
          const time = res.data;
          this.calculateLectureHours = time;
          this.classForm.lectureHours = time;
        });
      }
    },
    inputHours(value) {  
      if (value != "") {
        if (value.indexOf(".") == 0) {
          this.classForm.lectureHours = "0.";
        } else if (value.indexOf(".") > 0) {
          this.classForm.lectureHours = value.slice(0, value.indexOf(".") + 3);
        } else {
          this.classForm.lectureHours = value;
        }
      } else this.classForm.lectureHours = ""
    },
  },
};
</script>

<style lang="scss" scoped>
#video-cover {
  margin-right: 16px;
}
.devide_line {
  line-height: 32px;
  margin-left: 12px;
}
.unit_style {
  display: flex;
  flex-direction: row;
}
$textColor: #51627d;
/deep/ .period_form .el-form-item__content {
  margin-left: 16px !important;
}
/deep/ .el-input-group__prepend {
  background-color: #909399;
  border: 0px solid #dcdfe6;
  padding: 0 0px;
}
/deep/ .scale .el-input {
  width: 50%;
  color: $textColor;
  font-size: 12px;
}
.form-select {
  width: 100%;
}
/deep/ .el-form-item__content {
  .el-select.select {
    width: 100% !important;
  }
}
.upload_tip {
  width: 280px;
  text-align: center;
}
.upload_tip p {
  font-size: 14px;
  margin: 0;
  // line-height: 30px;
  color: #51627d;
}
.upload_tip p.img_tip {
  font-size: 12px;
  text-align: left;
  color: #606266;
}
/deep/ .el-range-editor--small.el-input__inner {
  width: 100%;
}
.form-text-center {
  text-align: center !important;
}
.input {
  width: 150px !important;
}
.photos_style {
  display: flex;
}
</style>
